// src/api/adminRbac.js
import api from "./api";

export const AdminRbacAPI = {
  listRoles: () => api("/admin/rbac/roles"),
  createRole: (payload) =>
    api("/admin/rbac/roles", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  updateRole: (id, payload) =>
    api(`/admin/rbac/roles/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    }),
  deleteRole: (id) =>
    api(`/admin/rbac/roles/${id}`, {
      method: "DELETE",
    }),

  listPermissions: () => api("/admin/rbac/permissions"),
  getRolePermissions: (id) => api(`/admin/rbac/roles/${id}/permissions`),
  setRolePermissions: (id, permissionKeys) =>
    api(`/admin/rbac/roles/${id}/permissions`, {
      method: "PUT",
      body: JSON.stringify({ permissionKeys }),
    }),
};
